class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);

        this.bindEvents();
        this.observeDOMChanges();
        this.handleIntersects();

        this.interceptCartApi();
    }

    bindEvents() {
        this.delegateBody.on("click", "button[name='checkout']", this.handleCheckout.bind(this));
        this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
        //document.addEventListener("variant:changed:gtm", this.handleVariantChange.bind(this));
    }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
            // For each mutation record, we look for added nodes
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    // If there are added nodes, we call handleIntersects to check for new items
                    this.handleIntersects();
                }
            }
        });

        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
            childList: true, // Observe direct children
            subtree: true, // and all descendants
            attributes: false // Set to true if you also want to observe attribute changes
        });
    }

    handleIntersects() {
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

        allIntersections.forEach((item) => {
            const observer = new IntersectionObserver(
                this.handleIntersection.bind(this),
                {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px",
                    threshold: 0.1, // Adjust the threshold as per your requirement
                }
            );

            observer.observe(item);
            item.dataset.observed = "true";
        });
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let data = false;

                try {
                    data = JSON.parse(
                        entry.target.querySelector('script[type="application/ld+json"]').textContent
                    );

                } catch (e) {
                    console.log("JSON parse failed", e);
                }


                if (!dataLayer || !data) return;

                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);
                console.log(data, "And pushed to dataLayer");
            }
        });
    }

    // find other solution for getting variant from the event
    handleVariantChange(event) {        
        const formState = event.detail.formState;
        const target = event.detail.target;
        const section = target.closest("section");
        const currentVariant = formState.variant;
            
        // get and update gtm script
        const dataElem = section?.querySelector('.product__gtm-script>script') || document.querySelector('.product__gtm-script>script');        
        if (!currentVariant || !dataElem) return;
        
        const data = JSON.parse(dataElem.textContent);
        const item = data.ecommerce.items[0];
        
        item.item_variant = currentVariant.public_title || "Default Title";
        item.item_id = currentVariant.id || "";
        item.item_sku = currentVariant.sku || "";
        item.price = currentVariant.price / 100;
        item.quantity = 1;
    
        data.ecommerce.value = currentVariant.price / 100;
    
        if (!dataLayer || !data) return;
    
        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
        console.log(data, "And pushed to dataLayer");

        dataElem.textContent = JSON.stringify(data);
    }

    interceptCartApi() {
        const originalFetch = window.fetch;
        const _this = this;

        window.fetch = async function (...args) {
            try {
                const [url, request] = [...args];

                // Trigger custom logic for cart clear API
                if (url.includes(`/cart/clear`)) _this.cartClear();
                if (url.includes(`/cart/update`)) _this.cartUpdate(request.body);

                const response = await originalFetch.apply(this, args);
                if (!response.ok) return response;
                
                 // Early return for non-cart-related APIs or missing conditions
                 if (url === '' || !dataLayer) return response;

                // Process cart actions based on URL
                if (url.includes(`/cart/add`)) {
                    const responseClone = response.clone();
                    const json = await responseClone.json(); 

                    _this.cartAdd(json, request);
                } else if (url.includes(`/cart/change`)) {
                    const responseClone = response.clone();
                    const json = await responseClone.json(); 

                    _this.cartChange(json);
                }

                return response;

            } catch (e) {
                console.error('Fetch interceptor error:', e);
                return originalFetch(...args);
            }
        };
    }

    async cartAdd(cart, request) {
        const cartItems = cart.items ? cart.items : [cart];

        const body = JSON.parse(request.body);        
        const quantity = body["quantity"];
        if (quantity) cartItems[0].quantity = Number(quantity);

        const listId = body["_gtm-list_id"];
        const listName = body["_gtm-list_name"];
        
        if (listId) cartItems[0]["_gtm-list_id"] = listId;
        if (listName) cartItems[0]["_gtm-list_name"] = listName;
        
        this.productAdded(cartItems);
    }

    async cartUpdate(body) {
        if (!body) return;
        const updates = JSON.parse(body).updates;
    
        const oldCart = await this.getCart();
        const cartItems = oldCart.items;
        let itemsAdded = [], itemsRemoved = [];
    
        cartItems.forEach(item => {            
            const newQuantity = updates[item.key];
            if (typeof newQuantity === "number") {
                const change = newQuantity - item.quantity;
                item.quantity = Math.abs(change);
    
                change < 1 ? itemsRemoved.push(item) : itemsAdded.push(item);
            }
        })

        itemsAdded = this.setLocationShoppingCart(itemsAdded);
        itemsRemoved = this.setLocationShoppingCart(itemsRemoved);
    
        this.productAdded(itemsAdded);
        this.productsRemoved(itemsRemoved);
    }

    async cartChange(cart) {
        const itemsAdded = this.setLocationShoppingCart(cart.items_added);
        const itemsRemoved = this.setLocationShoppingCart(cart.items_removed);

        this.productAdded(itemsAdded);
        this.productsRemoved(itemsRemoved);
    }

    async cartClear() {
        const cart = await this.getCart();
        this.productsRemoved(cart.items);
    }

    async getCart() {
        try {
            const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            });

            return await response.json();

        } catch (error) {
            console.log('Fetch Error:', error);
        }
    }

    productAdded(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const customEvent = {
            'event': 'custom_add_to_cart',
            'ecommerce': this.buildEcommerce(cartItems)
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_add_to_cart:", customEvent);
    }

    async productsRemoved(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const customEvent = {
              'event': "custom_remove_from_cart",
              'ecommerce': this.buildEcommerce(cartItems)
        }
  
        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_remove_from_cart:", customEvent);
    }

    handleCheckout() {
        const button = event.target.closest("button[name='checkout']");
        if (!button) return;

        const script = button.parentElement.querySelector('[type="application/ld+json"]');
        const settings = JSON.parse(script.innerText);

        if (!dataLayer || !settings) return;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(settings);

        console.log("dataLayer push -> checkoutFired:", settings);
    }

    handleSelectItem(event) {
        if (event.target.closest('[data-action="add-to-cart"]')) return;
        
        let target = event.target.closest('[data-action="ga-send-select"]');
        if (!target || !dataLayer) return;

        const settings = JSON.parse(target.dataset.selectSettings);
        if (!settings) return;

        const customEvent = {
            event: "custom_select_item",
            ecommerce: {
                item_list_id: settings.list_id,
                item_list_name: settings.list_name,
                currency: ShopifyAnalytics.meta.currency,
                items: [settings]
            }
          }
    
        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_select_item:", customEvent);
    }

    buildEcommerce(cartItems) {
        const items = [];
        let totalPrice = 0;        

        cartItems.forEach((item) => {            
            const price = typeof item.price === "number" ? item.price / 100 : Number(item.price);
            totalPrice += price * item.quantity;
            
            const product = {
                'item_id': item.sku || "",
                'item_name': item.untranslated_product_title || item.title || "",
                'item_variant': item.untranslated_variant_title || "Default Title",
                'price': price, 
                'quantity': item.quantity,
                'category': item.properties?.["_gtm-category"] || item["category"] || "Uncategorized",
                'category2': item.properties?.["_gtm-category2"] || item["category2"] || "Uncategorized",
                'item_brand': item.properties?.["_gtm-item_brand"] || item["brand"] || "",
                'list_id': item["_gtm-list_id"] || "",
                'list_name': item["_gtm-list_name"] || ""
            }

            items.push(product);
        });

        return {
            'value': totalPrice,
            'currency': ShopifyAnalytics.meta.currency,
            'items': items
        }
    }

    setLocationShoppingCart(array) {
        return array.map(item => {            
            item["_gtm-list_id"] = "shopping_cart"
            item["_gtm-list_name"] = "Shopping cart"

            const id = `#CartItem-${item.variant_id }-${item.view_key.replace(":", "")}`
            const lineItem = document.querySelector(id);
            
            if (!lineItem) return item;

            const category = lineItem.dataset.gtmCategory;
            const category2 = lineItem.dataset.gtmCategory2;
            const brand = lineItem.dataset.gtmItemBrand;

            if (category) item["category"] = category;
            if (category2) item["category2"] = category2;
            if (brand) item["brand"] = brand;

            return item;
        });
    }
}

new gTagEvents();